var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98806 7.31344C5.82296 7.31351 5.66407 7.24858 5.54388 7.13192L0.182675 1.92931C0.0667517 1.8061 0.00133656 1.64161 2.02555e-05 1.46999C-0.00129605 1.29838 0.0615876 1.13284 0.175607 1.00776C0.289626 0.882684 0.446015 0.807691 0.612284 0.79836C0.778553 0.789029 0.941918 0.846077 1.06844 0.957653L5.98676 5.7305L10.9077 0.957653C11.0329 0.836237 11.1997 0.77105 11.3715 0.776432C11.4566 0.779096 11.5403 0.799006 11.618 0.835023C11.6956 0.871041 11.7655 0.922461 11.8239 0.986349C11.8822 1.05024 11.9278 1.12534 11.9579 1.20737C11.9881 1.2894 12.0023 1.37675 11.9997 1.46444C11.9971 1.55212 11.9778 1.63843 11.9429 1.71842C11.9079 1.79841 11.858 1.87052 11.796 1.93064L6.43223 7.13192C6.31204 7.24858 6.15315 7.31351 5.98806 7.31344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f2abf0611860838896d1099b27e5933d.svg";
export { ForwardRef as ReactComponent };